import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import {ITheme} from "../../../themes/types";

interface SizeProps{
  size?: string;
  theme?: ITheme;
}

const size = (props: SizeProps) => {
  if (props.size === 'small') return props.theme ? props.theme.icons.small : "16px";
  else if (props.size === 'medium') return props.theme ? props.theme.icons.medium : "24px";
  else if (props.size === 'large') return props.theme ? props.theme.icons.large : "32px";
  return '1em';
};

interface ComponentProps{
  size?: string;
  color?: string;
  float?: boolean;
  inline?: boolean;
  pointer?: boolean;
  tabIndex?: string;
  title?: string;
  onClick?: (event: MouseEvent) => void;
  onKeyDown?: (event: KeyboardEvent) => void;
  marginAuto?: boolean;
}

const extendIconFill = (WrappedComponent: React.FunctionComponent<ComponentProps & any>) => {
  /**
   * Additional icon functionality can be defined here in ExtendedIcon.
   */
  class ExtendedIconFill extends Component<ComponentProps & any, {}> {
    /*static displayName = `ExtendedIcon(${WrappedComponent.displayName ||
      WrappedComponent.name ||
      'Component'})`;*/

    render() {
      const { size, color, float, inline, pointer, ...otherProps } = this.props;
      return <WrappedComponent {...otherProps} />;
    }
  }

  return styled(ExtendedIconFill)`
    width: ${size};
    height: ${size};
    fill: ${props =>
      (props.theme.colors && props.theme.colors.accent) ||
      props.theme.colors.accent};
    transition: 0.5s fill;
    display: ${props => (props.inline ? 'inline' : 'block')};
    ${props => props.float && `float: ${props.float};`};
    ${props => props.pointer && 'cursor: pointer;'};
    ${props => props.marginAuto && 'margin: auto;'};
  `;
};

export default extendIconFill;
